<template>
    <title-card-list :disable-title="disableTitle"
                     title="Registration survey links"
                     class="mt-2"
                     help="subpanel-settings-registration-links">

        <registration-link :sub-panel="subPanel" :url="universalUrl"/>

        <registration-link v-for="locale in subPanel.locales" :key="locale.code"
                           :sub-panel="subPanel"
                           :locale="locale"/>
    </title-card-list>
</template>

<script>

import Json from 'vue-json-pretty';
import RegistrationLink from "./RegistrationLink";
import TitleCardList from "../../../components/UI/TitleCardList";

export default {

    components: {
        Json,
        RegistrationLink,
        TitleCardList
    },

    props: {
        subPanel: {
            type: Object,
            required: true
        },
        disableTitle: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    computed: {
        universalUrl() {
            return window.location.protocol + '//' + window.location.hostname + '/app/' + this.subPanel.id;
        }
    },
}
</script>
